// ---------------------------------------------------------------------------
// L'ÉCHELLE DE L'ACTIVITÉ — une seule taille de référence, le reste à l'échelle
// ---------------------------------------------------------------------------
// Toji (21/10) : « mets juste la taille max qui est autorisée par Discord pour
// l'activité, tu mets cette taille, et tu fais tout en fonction de cette
// taille spécifiquement. »
//
// Discord ne documente AUCUNE taille de cadre (ni maximum, ni référence, ni
// ratio — docs « Activities », « Layout », « Embedded App SDK », lues le
// 21/10) : le cadre est le client, et le plus grand qu'il puisse donner est
// l'écran entier. La référence retenue est donc le plein écran Full HD,
// 1920 × 1080 — l'écran le plus répandu, et le ratio des épisodes.
//
// À cette référence, l'interface est la feuille de style actuelle agrandie
// 1,5 fois : c'est dire que la page se met en page sur 1280 px de large, et
// que tout cadre plus grand en reçoit la même image, agrandie d'un seul
// facteur (`zoom` CSS : le texte est re-rendu net, les clics tombent juste).
//
//   · plus petit que 1280 px de large (téléphone, fenêtre étroite, vignette
//     320 × 180) : échelle 1, la mise en page adaptative existante s'applique
//     telle quelle — on n'y descend jamais sous la taille de lecture actuelle ;
//   · trop bas : la page garde au moins 560 px de haut en unités de page
//     (en-tête, une rangée, la barre du lecteur), l'échelle se règle dessus.
// ---------------------------------------------------------------------------

export const REFERENCE = Object.freeze({ largeur: 1920, hauteur: 1080 });
export const GRANDISSEMENT = 1.5;
export const LARGEUR_DE_PAGE = REFERENCE.largeur / GRANDISSEMENT;
export const HAUTEUR_DE_PAGE_MINI = 560;

/** L'échelle d'un cadre de `l` × `h` pixels CSS. Arrondie AU-DESSOUS au
 *  centième : arrondir au-dessus ferait déborder la page d'un pixel. */
export function echelleDuCadre(l, h) {
  if (!(l > 0 && h > 0)) return 1;
  const e = Math.min(l / LARGEUR_DE_PAGE, h / HAUTEUR_DE_PAGE_MINI);
  return e > 1 ? Math.floor(e * 100) / 100 : 1;
}

// Sous `zoom`, `getBoundingClientRect`, `clientX/Y` et `innerWidth/Height`
// parlent en pixels d'ÉCRAN, alors que ce qu'on écrit dans `style` est en
// pixels de PAGE. Tout placement calculé passe donc par ces conversions.
export const zoomPage = () => parseFloat(document.documentElement.style.zoom) || 1;
export const enPage = (px) => px / zoomPage();
export const largeurPage = () => innerWidth / zoomPage();
export const hauteurPage = () => innerHeight / zoomPage();
export function rectPage(el) {
  const r = el.getBoundingClientRect();
  const k = zoomPage();
  return { left: r.left / k, right: r.right / k, top: r.top / k, bottom: r.bottom / k, width: r.width / k, height: r.height / k };
}
